import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('cts_token');
    const savedUser = localStorage.getItem('cts_user');
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch { /* ignore */ }
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem('cts_token', res.data.token);
    localStorage.setItem('cts_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const register = useCallback(async (data) => {
    const res = await authAPI.register(data);
    localStorage.setItem('cts_token', res.data.token);
    localStorage.setItem('cts_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('cts_token');
    localStorage.removeItem('cts_user');
    setUser(null);
  }, []);

  const isStaff = user?.user_type === 'staff';
  const isAdmin = user?.role === 'admin';
  const isClient = user?.user_type === 'client';

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isStaff, isAdmin, isClient }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
